export var RootAction;
(function (RootAction) {
    RootAction["JOIN_VAULT"] = "vault:join";
    RootAction["LEAVE_VAULT"] = "vault:leave";
    RootAction["UPDATE_VAULT_USER"] = "vault:update-user";
    RootAction["UPDATE_VAULT"] = "vault:update";
    RootAction["VAULT_STATUS"] = "vault:status";
    RootAction["UPDATE_FILE_ACCESS_HISTORY"] = "vault:update-file-access-history";
})(RootAction || (RootAction = {}));
